/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

import * as Msdyn365 from '@msdyn365-commerce/core';
/**
 * GetAuthTokenInput Input Action
 */
export class BrightSpotContentInput extends Msdyn365.CommerceEntityInput implements Msdyn365.IActionInput {
    private brightspotUrl: string = '';
    constructor(brightspotUrl: string) {
        super({ shouldCacheOutput: true, cacheObjectType: 'bspagecache', cacheKey: 'bspagecache' });
        this.brightspotUrl = brightspotUrl;
    }

    public getBrightspotUrl = () => this.brightspotUrl;
    public getCacheKey = () => `bspagecache`;
    public getCacheObjectType = () => 'bspagecache';
    public dataCacheType = (): Msdyn365.CacheType => 'request';
}

const createInput = (inputData: Msdyn365.ICreateActionContext<Msdyn365.IGeneric<Msdyn365.IAny>>): Msdyn365.IActionInput => {
    if (inputData.config && inputData.config.brightspotPageUrl) {
        return new BrightSpotContentInput(inputData.config.brightspotPageUrl);
    }
    return new BrightSpotContentInput('');
};

async function action(input: BrightSpotContentInput, ctx: Msdyn365.IActionContext): Promise<any> {
    const res = await Msdyn365.sendRequest<any>(
        input.getBrightspotUrl(),
        'get',
        null,
        { headers: {'Accept-Encoding': 'gzip'} }
    );

    return res.data;
}

export default Msdyn365.createObservableDataAction({
    id: 'BsPageCache',
    action: <Msdyn365.IAction<any>>action,
    input: createInput
});
